import { Link, useLocation } from "react-router-dom";
import { Car, Gauge, ClockCounterClockwise, ShieldCheck, Scales } from "@phosphor-icons/react";

export const Header = () => {
  const { pathname } = useLocation();
  const nav = [
    { to: "/", label: "New Appraisal", icon: Gauge, id: "nav-appraise" },
    { to: "/state-laws", label: "State Laws", icon: Scales, id: "nav-states" },
  ];
  return (
    <header
      className="border-b border-white/10 bg-[#0F0F11]/95 sticky top-0 z-40 shadow-2xl backdrop-blur-md print:hidden"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3.5 group" data-testid="brand-link">
            <div className="relative flex items-center justify-center">
              <div className="w-9 h-9 bg-gradient-to-tr from-[#C5A059] to-[#E5C17B] rounded-sm transform rotate-45 shadow-md shadow-[#C5A059]/20 flex items-center justify-center transition-transform group-hover:rotate-[135deg] duration-500">
                <Car weight="fill" className="w-4 h-4 text-black transform -rotate-45 group-hover:rotate-[-135deg] duration-500" />
              </div>
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h1 className="text-xl sm:text-2xl font-display tracking-tight text-white">
                  CARVALUE<span className="italic text-[#C5A059] font-light">RECOVERY</span>
                </h1>
                <span className="hidden sm:inline-flex items-center gap-1 px-2.5 py-0.5 text-[11px] uppercase tracking-wider font-semibold bg-[#C5A059]/10 text-[#E5C17B] border border-[#C5A059]/30 rounded-sm">
                  <ShieldCheck weight="fill" className="w-3 h-3 text-[#C5A059]" />
                  Appraisal Grade
                </span>
              </div>
              <p className="text-[11px] tracking-wide text-gray-400 hidden md:block">
                Certified Inherent Diminished Value &amp; Property Loss Valuation
              </p>
            </div>
          </Link>

          <nav className="flex items-center bg-[#0A0A0B] p-1 rounded-lg border border-white/10 text-xs tracking-wider">
            {nav.map((n) => {
              const active = pathname === n.to || (n.to === "/" && pathname.startsWith("/appraisal"));
              const Icon = n.icon;
              return (
                <Link
                  key={n.to}
                  to={n.to}
                  data-testid={n.id}
                  className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-md transition-all uppercase ${
                    active
                      ? "bg-[#161619] text-[#C5A059] border border-[#C5A059]/40 font-semibold"
                      : "text-gray-400 hover:text-white border border-transparent"
                  }`}
                >
                  <Icon size={16} weight={active ? "fill" : "regular"} />
                  <span className="hidden sm:inline">{n.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
};
